module.exports = __webpack_public_path__ + "img/Middle-Vertical-Rectangular-Attachment-16.4961120c.png";